module.exports = __webpack_public_path__ + "static/media/GitHubLogo.39c1521f.svg";